const content: { [key: string]: any } = {
  permissionRoleList: 'Permission Roles',
};

export default content;
